export default __webpack_public_path__ + "static/media/goldbar.8f1807e1.png";